import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  TextField,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';

const WEEKDAYS = [
  { key: 'MO', index: 0 },
  { key: 'TU', index: 1 },
  { key: 'WE', index: 2 },
  { key: 'TH', index: 3 },
  { key: 'FR', index: 4 },
  { key: 'SA', index: 5 },
  { key: 'SU', index: 6 },
];

export default function WeeklyPattern({
  interval,
  onIntervalChange,
  byWeekday,
  onByWeekdayChange,
}) {
  const { t } = useTranslation('common');

  const handleWeekdayToggle = (event, newWeekdays) => {
    onByWeekdayChange(newWeekdays);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Interval Input */}
      <Box display="flex" alignItems="center" gap={1}>
        <Typography>{t('common:rrule.pattern.every')}</Typography>
        <TextField
          type="number"
          value={interval}
          onChange={(e) => onIntervalChange(Math.max(1, parseInt(e.target.value) || 1))}
          slotProps={{ htmlInput: { min: 1, style: { textAlign: 'center' } } }}
          size="small"
          sx={{ width: 70 }}
        />
        <Typography>{t('common:rrule.pattern.every_weeks')}</Typography>
      </Box>

      {/* Day of week selector */}
      <Box display="flex" alignItems="center" gap={1}>
        <Typography>{t('common:rrule.pattern.on')}</Typography>
        <ToggleButtonGroup
          value={byWeekday}
          onChange={handleWeekdayToggle}
          aria-label="weekday selection"
          size="small"
        >
          {WEEKDAYS.map((day) => (
            <ToggleButton
              key={day.key}
              value={day.key}
              aria-label={t(`common:rrule.weekdays.${day.key.toLowerCase()}`)}
              sx={{ px: 1.5 }}
            >
              {t(`common:rrule.weekdays.${day.key.toLowerCase()}_short`)}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
}
